import { calculateGridHeight, showNotification } from '@/services/calculate'
import { convertFilterDate } from '@/services/convert'
import { instance, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import { socketEvents, tableName } from '@/services/config'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import ActionRenderer from './actionRendere'
import Pagination from '@/components/DynamicComponents/Pagination'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import moment from 'moment-timezone'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    Pagination,
  },
  props: ['propData'],
  data: function() {
    return {
      columnList: [],
      data: [],
      count: 0,
      loading: false,
      gridOptions: {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: false,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        suppressContextMenu: true,
        defaultColDef: {
          sortable: true,
          suppressMenu: true,
          resizable: true,
          editable: false,
          floatingFilter: false,
        },
      },
      width: '100%',
      height: '430px',
      frameworkComponents: null,
      tableState: null,
      visible: false,
      filterForm: {
        pageSize: null,
        currentPage: 0,
        sortColumn: 'updatedDate',
        isAscending: false,
        isActive: this.propData.isActive,
      },
      userDetails: null,
      isResized: false,
      openPopup: false,
      form: {
        projectName: undefined,
        isArchive: false,
      },
      projectId: undefined,
      loader: false,
      isloaded: true,
      title: 'Viewing My Projects',
      sortedBy: undefined,
      sideBar: null,
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.filterForm.pageSize = settings.application.defaultRecord
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'))
    this.loadingConfig()
  },
  mounted() {
    this.$root.$off('restoreProject')
    this.$root.$off('deleteProject')
    this.$root.$off('cloneProject')
    this.$root.$on('onChange', this.checkPanel)
    this.$root.$on('filterProject', this.filterProject)
    this.$root.$on('restoreProject', this.restoreProject)
    this.$root.$on('deleteProject', this.deleteProject)
    this.$root.$on('cloneProject', this.cloneProject)
    this.$root.$on('archiveProject', this.archiveProject)
    this.$socketHub.$on('message-received', this.messageReceived)
    this.$root.$on('abortProject', this.abortProject)
  },
  beforeDestroy() {
    this.$root.$off('onChange')
    this.$root.$off('filterProject')
    this.$root.$off('restoreProject')
    this.$root.$off('cloneProject')
    this.$root.$off('archiveProject')
    this.$socketHub.$off('message-received')
    this.$root.$off('abortProject')
  },
  methods: {
    loadingConfig() {
      this.frameworkComponents = {
        actionCellRenderer: ActionRenderer,
        toolTipRenderer: ToolTipRenderer,
      }
      this.sideBar = {
        toolPanels: [
          {
            id: 'columns',
            labelDefault: 'Column Settings',
            labelKey: 'columns',
            iconKey: 'columns',
            toolPanel: 'agColumnsToolPanel',
            toolPanelParams: {
              suppressRowGroups: true,
              suppressValues: true,
              suppressColumnMove: true,
              suppressPivots: true,
              suppressPivotMode: true,
              suppressColumnSelectAll: true,
            },
            minWidth: 225,
            maxWidth: 225,
            width: 225,
          },
        ],
        position: 'right',
        defaultToolPanel: 'columns',
      }
    },

    onChange(e, column) {
      column.isCheck = e.target.checked
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: column.colId,
            hide: !column.isCheck,
          },
        ],
      })
      this.isResized = true
      this.gridOptions.api.sizeColumnsToFit()
    },

    onColumnResized(e) {
      if (e.finished) {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        if (e.source !== 'sizeColumnsToFit' && e.source !== 'api') {
          this.updateColumnSetting()
        }
        this.isResized = true
      }
    },

    columnMoved(e) {
      this.tableState = this.gridOptions.columnApi.getColumnState()
      this.updateColumnSetting()
    },

    checkPanel(flag) {
      this.height = calculateGridHeight(
        this.propData.tableId,
        this.count > this.filterForm.pageSize,
        false,
        true,
      )
      if (flag) {
        if (this.count > this.filterForm.pageSize) {
          this.height = Number(this.height.split('px')[0]) + 130 + 'px'
        } else {
          this.height = Number(this.height.split('px')[0]) + 173 + 'px'
        }
      } else {
        if (this.count > this.filterForm.pageSize) {
          this.height = Number(this.height.split('px')[0]) - 201 + 'px'
        } else {
          this.height = Number(this.height.split('px')[0]) - 164 + 'px'
        }
      }
    },

    showDrawer() {
      this.visible = !this.visible
    },

    getProjects(params) {
      this.loading = true
      if (this.propData.isActive) {
        let filter = sessionStorage.getItem('projectFilter')
        if (filter) {
          filter = JSON.parse(filter)
          if (filter.fromCreatedDate && filter.toCreatedDate) {
            let fromData =
              moment(filter.fromCreatedDate).format('YYYY-MM-DD') + ' 00:00:00'
            fromData = moment(fromData)
            filter.fromCreatedDate = convertFilterDate(fromData)
            let toDate =
              moment(filter.toCreatedDate).format('YYYY-MM-DD') + ' 23:59:59'
            toDate = moment(toDate)
            filter.toCreatedDate = convertFilterDate(toDate)
          }
          if (filter.fromUpdatedDate && filter.toUpdatedDate) {
            let fromDate2 =
              moment(filter.fromUpdatedDate).format('YYYY-MM-DD') + ' 00:00:00'
            fromDate2 = moment(fromDate2)
            filter.fromUpdatedDate = convertFilterDate(fromDate2)
            let toDate2 =
              moment(filter.toUpdatedDate).format('YYYY-MM-DD') + ' 23:59:59'
            toDate2 = moment(toDate2)
            filter.toUpdatedDate = convertFilterDate(toDate2)
          }
          this.filterForm = { ...this.filterForm, ...filter }
        }
      }
      params.api.closeToolPanel()
      this.loadProjects(params)
    },

    filterProject(filter) {
      this.filterForm = { ...this.filterForm, ...filter }
      this.data = []
      this.loading = true
      this.filterForm.currentPage = 0
      this.loadProjects(this.gridOptions)
    },

    loadProjects(params) {
      if (this.columnList.length === 0) {
        params.api.sizeColumnsToFit()
        this.checkPreference()
      }
      if (this.filterForm) {
        if (this.filterForm.viewAll) {
          this.title = 'Viewing All Projects'
        } else {
          this.title = 'Viewing My Projects'
        }
      }
      instance
        .post(this.propData.url, this.filterForm)
        .then(response => {
          this.data = _.get(response.data, 'result', [])
          this.count = _.get(response.data, 'totalCount', 0)
          if (this.count > this.filterForm.pageSize) {
            this.height =
              Number(
                calculateGridHeight(
                  this.propData.tableId,
                  this.count > this.filterForm.pageSize,
                ).split('px')[0],
              ) +
              40 +
              'px'
          } else {
            this.height = calculateGridHeight(
              this.propData.tableId,
              this.count > this.filterForm.pageSize,
            )
          }
          if (this.count > this.filterForm.pageSize) {
            this.height = Number(this.height.split('px')[0]) - 36 + 'px'
          }
          this.loading = false
          this.$root.$emit('projectCount', this.count, this.title)
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    // Ag Grid sort method
    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function(s) {
          return s.sort != null
        })
        .map(function(s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.loading = true
      this.data = []
      if (sortData.length > 0) {
        this.filterForm.sortColumn = sortData[0]['colId']
        this.filterForm.isAscending = sortData[0]['sort'] === 'asc'
      } else {
        this.filterForm.sortColumn = 'updatedDate'
        this.filterForm.isAscending = false
      }
      this.getProjects(this.gridOptions)
    },

    updateColumnSetting() {
      const request = {
        tableName: this.propData.isActive
          ? tableName.projectDashboard
          : tableName.projectRestore,
        columnDetails: JSON.stringify(this.tableState),
      }
      instance
        .put(projectAPIs.columns.update, request)
        .then(response => {
          if (this.propData.isActive) {
            this.userDetails.active_Fields = _.get(
              response.data,
              'result.columnDetails',
              [],
            )
          } else {
            this.userDetails.deactive_Fields = _.get(
              response.data,
              'result.columnDetails',
              [],
            )
          }
          localStorage.removeItem('userDetails')
          localStorage.setItem('userDetails', JSON.stringify(this.userDetails))
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    async checkPreference() {
      const element = {
        header: 'Percent Complete',
        colId: 'percentComplete',
        width: 100,
        hide: false,
        pinned: null,
        sort: null,
        sortIndex: null,
        aggFunc: null,
        rowGroup: false,
        rowGroupIndex: null,
        pivot: false,
        pivotIndex: null,
        flex: null,
      }
      let type = tableName.projectRestore
      switch (this.propData.isActive) {
        case true:
          type = tableName.projectDashboard
          break
      }
      const preference = await this.getColumnSettings(type)
      if (preference && preference.length > 0) {
        const isPresent = preference.find(i => i.colId === 'percentComplete')
        if (!isPresent) {
          const index = preference.findIndex(i => i.colId === 'createdDate')
          preference.splice(index, 0, element)
        }
        this.isloaded = false
        preference.forEach(element => {
          if (element.colId !== 'action') {
            this.columnList.push({
              colId: element.colId,
              hide: element.hide,
              isCheck: !element.hide,
              name: this.propData.columns.find(i => i.field === element.colId)
                .headerName,
            })
            if (element.sort) {
              this.filterForm.sortColumn = element.colId
              this.filterForm.isAscending = element.sort === 'asc'
            }
          } else {
            if (element.colId === 'action') {
              element.pinned = 'right'
              element.suppressMovable = true
              element.width = 120
              this.propData.columns.map(e => {
                if (e.field === 'action') {
                  e.suppressMovable = true
                  e.pinned = 'right'
                }
              })
            }
          }
        })
        this.gridOptions.columnApi.applyColumnState({
          state: preference,
          applyOrder: true,
        })
      } else {
        const state = this.gridOptions.columnApi.getColumnState()
        state
          .filter(i => i.colId !== 'action')
          .forEach(element => {
            this.columnList.push({
              colId: element.colId,
              hide: element.hide,
              isCheck: !element.hide,
              name: this.propData.columns.find(i => i.field === element.colId)
                .headerName,
            })
          })
      }
    },

    refreshProject() {
      if (
        this.filterForm.sortColumn !== 'updatedDate' ||
        this.filterForm.isAscending
      ) {
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'updatedDate',
              sort: 'desc',
            },
          ],
          defaultState: { sort: null },
        })
        this.filterForm.sortColumn = 'updatedDate'
        this.filterForm.isAscending = false
        this.tableState = this.gridOptions.columnApi.getColumnState()
        this.updateColumnSetting()
      }
      this.loading = true
      this.getProjects(this.gridOptions)
    },

    restoreProject(data) {
      const that = this
      let title = 'Project'
      if (data.projectName && data.clientName) {
        title = `${data.clientName} - ${data.projectName}`
      } else if (data.projectName) {
        title = `${data.projectName}`
      } else if (data.clientName) {
        title = `${data.clientName}`
      }
      this.$confirm({
        title: `Are you sure you want to restore '${title}' ?`,
        onOk() {
          that.confirmRestore(data.id)
        },
        onCancel() {},
        class: 'test',
      })
    },

    deleteProject(data) {
      const that = this
      let title = 'Project'
      if (data.projectName && data.clientName) {
        title = `${data.clientName} - ${data.projectName}`
      } else if (data.projectName) {
        title = `${data.projectName}`
      } else if (data.clientName) {
        title = `${data.clientName}`
      }
      this.$confirm({
        title: `Are you sure you want to delete '${title}' ?`,
        content: h => (
          <div style="color:red;">
            <p>This action will move this project to restore project section</p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(data.id)
        },
        onCancel() {},
        class: 'test',
      })
    },

    confirmDelete(id) {
      this.loading = true
      instance
        .delete(projectAPIs.project.delete(id))
        .then(response => {
          this.getProjects(this.gridOptions)
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    onPagination(page) {
      this.loading = true
      this.filterForm.currentPage = page
      this.data = []
      this.getProjects(this.gridOptions)
    },

    cloneProject(data) {
      this.form.projectName =
        `${data.projectName ? data.projectName : data.id}` + ' - Copy'
      this.form.isArchive = data.isArchive
      this.projectId = data.id
      this.openPopup = true
    },

    cloneProjectDetails() {
      this.loader = true
      instance
        .post(projectAPIs.project.clone(this.projectId), this.form)
        .then(response => {
          this.$emit('showLoader', true, _.get(response.data, 'message', ''))
          this.loader = false
          this.openPopup = false
          this.projectId = undefined
          this.form.projectName = undefined
          showNotification(
            'warning',
            'Project',
            _.get(response.data, 'message', ''),
          )
        })
        .catch(error => {
          this.$emit('showLoader', false, null)
          this.loader = false
          errorService(error)
        })
    },

    handleCancel() {
      this.openPopup = false
      this.projectId = undefined
      this.form.projectName = undefined
    },

    confirmRestore(id) {
      this.loading = true
      instance
        .patch(projectAPIs.project.restore(id))
        .then(response => {
          this.getProjects(this.gridOptions)
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    getColumnSettings(type) {
      return instance
        .get(projectAPIs.columns.list(type))
        .then(response => {
          const details = _.get(response.data, 'result', null)
          return details && details.columnDetails
            ? JSON.parse(details.columnDetails)
            : details
        })
        .catch(error => {
          errorService(error)
        })
    },

    gridColumnsChanged(value) {
      if (value && value.source === 'toolPanelUi') {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        this.updateColumnSetting()
      }
    },

    archiveProject(data) {
      const that = this
      let title = 'Project'
      if (data.projectName && data.clientName) {
        title = `${data.clientName} - ${data.projectName}`
      } else if (data.projectName) {
        title = `${data.projectName}`
      } else if (data.clientName) {
        title = `${data.clientName}`
      }
      this.$confirm({
        title: `Are you sure you want to ${
          data.isArchive ? 'unarchive' : 'archive'
        } '${title}' ?`,
        content: h => (
          <div style="color:red;">
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmArchive(data)
        },
        onCancel() {},
        class: 'test',
      })
    },

    confirmArchive(data) {
      this.loading = true
      let url = projectAPIs.project.archive(data.id)
      if (data.isArchive) {
        url = projectAPIs.project.unarchive(data.id)
      }
      instance
        .post(url)
        .then(response => {
          this.loading = false
          showNotification(
            'warning',
            'Project',
            _.get(response.data, 'message', ''),
          )
          this.loadProjects(this.gridOptions)
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    abortProject(data) {
      this.loading = true
      const url = projectAPIs.project.abort(data.id)
      instance
        .post(url)
        .then(response => {
          this.loading = false
          showNotification(
            'warning',
            'Project',
            _.get(response.data, 'message', ''),
          )
          this.loadProjects(this.gridOptions)
        })
        .catch(error => {
          this.loading = false
          errorService(error)
          this.loadProjects(this.gridOptions)
        })
    },

    // Socket listen
    messageReceived: function(message) {
      this.$notification.destroy()
      const data = JSON.parse(message.message)
      if (data.EventType === socketEvents.projectCloned) {
        this.$emit('showLoader', false, null)
        this.loadProjects(this.gridOptions)
      } else if (data.EventType === socketEvents.error) {
        showNotification(
          'error',
          'Socket',
          _.get(data, 'Result.Message', null),
        )
      } else if (
        data.EventType === socketEvents.projectArchived ||
        data.EventType === socketEvents.projectUnArchived
      ) {
        if (data.Status === 'ERROR') {
          showNotification(
            'error',
            'Socket',
            _.get(data, 'Result.Message', null),
          )
        } else {
          this.loadProjects(this.gridOptions)
        }
      }
    },
  },
}
